import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './fonts'
import './tokens.css'
import './app.css'
import App from './App'
import ErrorBoundary from './shell/ErrorBoundary'
import { initErrorReporting } from './lib/report'

// Телеметрия ставится первой строкой: всё, что упадёт ниже (включая сам
// render), должно быть поймано и отправлено на сервер, а не пропасть в
// консоли телефона, куда всё равно никто не заглянет.
initErrorReporting()

const root = document.getElementById('root')
if (!root) throw new Error('agentbox: не найден #root')

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary scope="панель">
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
